/* eslint-disable */
const url_base_research_prod = 'https://research-service-dot-whr-lar-returns-portal.appspot.com/research'
const url_email_prod = 'https://email-service-dot-whr-lar-returns-portal.appspot.com/email'
const url_return_solicitation_prod = 'https://return-solicitation-dot-whr-lar-returns-portal.appspot.com'

const url_base_research_qa = 'https://research-service-dot-whr-lar-returns-portal-qa.appspot.com/research'
const url_email_qa = 'https://email-service-dot-whr-lar-returns-portal-qa.appspot.com/email'
const url_return_solicitation_qa = 'https://return-solicitation-dot-whr-lar-returns-portal-qa.appspot.com'

const base_dev = 'http://localhost'

const customer_port = 8081
const database_port = 8082
const email_port = 8083
const files_port = 8084
const inverse_order_port = 8085
const login_port = 8086
const research_port = 8087
const return_solicitation_port = 8088
const return_tracking_port = 8089
const sap_hybris_port = 8090
const sap_pixi_port = 8091
const schedule_port = 8092
const sheets_port = 8093
const user_management_port = 8094

const PROD_VERSION = 'PROD_1.0.0'
const QA_VERSION = 'QA_1.0.0'

export default {
  PROD: {
    BACK_OFFICE: {
      DATABASE_ACCESS: {
        BASE_URL: 'https://database-acess-dot-whr-lar-returns-portal.appspot.com'
      },
      REQUEST_APPROVAL: {
        RESEARCH: {
          RESEARCH_ALL: `${url_base_research_prod}/all`,
          RESEARCH_FATURATED: `${url_base_research_prod}/faturated`,
          RESEARCH_PENDING: `${url_base_research_prod}/pending`,
          RESEARCH_WAITING_COLLECTION_DATE: `${url_base_research_prod}/waiting-for-collection-date`,
          RESEARCH_WAITING_OI: `${url_base_research_prod}/waiting-for-oi`,
          RESEARCH_WAITING_REVENUE: `${url_base_research_prod}/waiting-revenue`
        },
        INVERSE_ORDER: {
          BASE_URL: 'https://inverse-order-service-dot-whr-lar-returns-portal.appspot.com/inverse-order'
        },
        REQUEST_APPROVAL: {
          BASE_URL: `${url_return_solicitation_prod}/return-request`
        },
        SCHEDULE_COLLECTION: {
          BASE_URL: 'https://schedule-collection-dot-whr-lar-returns-portal.appspot.com/orders'
        },
        SHEETS: {
          BASE_URL: 'https://sheets-dot-whr-lar-returns-portal.appspot.com'
        }
      },
      USER_MANAGEMENT: {
        BASE_URL: 'https://user-management-dot-whr-lar-returns-portal.appspot.com/user-management'
      },
      AUTH: {
        BASE_URL: 'https://login-dot-whr-lar-returns-portal.appspot.com'
      }
    },
    CLIENT: {
      CUSTOMER: {
        BASE_URL: 'https://customer-service-dot-whr-lar-returns-portal.appspot.com'
      },
      EMAIL: {
        BASE_URL: url_email_prod
      },
      RETURN_SOLICITATION: {
        ITEMS: {
          BASE_URL: `${url_return_solicitation_prod}/return-request/materials`
        },
        RETURN_SOLICITATION: {
          BASE_URL: `${url_return_solicitation_prod}/return-request`,
          EMAIL_URL: url_email_prod
        },
        SPECIFIC_FIELDS: {
          BASE_URL: `${url_return_solicitation_prod}`
        }
      },
      RETURN_TRACKING: {
        SOLICITATIONS: {
          BASE_URL: 'https://return-tracking-dot-whr-lar-returns-portal.appspot.com'
        }
      },
      SCHEDULE_COLLECTION: {
        COLLECTIONS: {
          BASE_URL: 'https://schedule-collection-dot-whr-lar-returns-portal.appspot.com/orders'
        }
      }
    },
    MICRO_SERVICES: {
      SAP_HYBRIS: {
        ROUTES: {
          BASE_URL: 'http://www.devolucao.lojapecasoriginais.com.br',
          TOKEN_VALIDATION_URL: 'https://lojapecasoriginais.com.br/usertoken/validate'
        }
      },
      SCHEDULE_COLLECTION: {
        EMAIL: url_email_prod
      },
      SHEETS: {
        EMAIL: url_email_prod
      },
      USER_MANAGEMENT: {
        EMAIL: url_email_prod
      },
      CAUSE: {
        CAUSE_LIST: `${url_return_solicitation_prod}/return-request`,
      },
      FILES: {
        BASE_URL: 'https://files-service-dot-whr-lar-returns-portal.appspot.com/files'
      }
    }
  },
  QA: {
    BACK_OFFICE: {
      DATABASE_ACCESS: {
        BASE_URL: 'https://database-acess-dot-whr-lar-returns-portal-qa.appspot.com/'
      },
      REQUEST_APPROVAL: {
        RESEARCH: {
          RESEARCH_ALL: `${url_base_research_qa}/all`,
          RESEARCH_FATURATED: `${url_base_research_qa}/faturated`,
          RESEARCH_PENDING: `${url_base_research_qa}/pending`,
          RESEARCH_WAITING_COLLECTION_DATE: `${url_base_research_qa}/waiting-for-collection-date`,
          RESEARCH_WAITING_OI: `${url_base_research_qa}/waiting-for-oi`,
          RESEARCH_WAITING_REVENUE: `${url_base_research_qa}/waiting-revenue`
        },
        INVERSE_ORDER: {
          BASE_URL: 'https://inverse-order-service-dot-whr-lar-returns-portal-qa.appspot.com/inverse-order'
        },
        REQUEST_APPROVAL: {
          BASE_URL: `${url_return_solicitation_qa}/return-request`
        },
        SCHEDULE_COLLECTION: {
          BASE_URL: 'https://schedule-collection-dot-whr-lar-returns-portal-qa.appspot.com/orders'
        },
        SHEETS: {
          BASE_URL: 'https://sheets-dot-whr-lar-returns-portal-qa.appspot.com'
        }
      },
      USER_MANAGEMENT: {
        BASE_URL: 'https://user-management-dot-whr-lar-returns-portal-qa.appspot.com/user-management'
      },
      AUTH: {
        BASE_URL: 'https://login-dot-whr-lar-returns-portal-qa.appspot.com'
      }
    },
    CLIENT: {
      CUSTOMER: {
        BASE_URL: 'https://customer-service-dot-whr-lar-returns-portal-qa.appspot.com'
      },
      EMAIL: {
        BASE_URL: url_email_qa
      },
      RETURN_SOLICITATION: {
        ITEMS: {
          BASE_URL: `${url_return_solicitation_qa}/return-request/materials`
        },
        RETURN_SOLICITATION: {
          BASE_URL: `${url_return_solicitation_qa}/return-request`,
          EMAIL_URL: url_email_qa
        },
        SPECIFIC_FIELDS: {
          BASE_URL: `${url_return_solicitation_qa}`
        }
      },
      RETURN_TRACKING: {
        SOLICITATIONS: {
          BASE_URL: 'https://return-tracking-dot-whr-lar-returns-portal-qa.appspot.com'
        }
      },
      SCHEDULE_COLLECTION: {
        COLLECTIONS: {
          BASE_URL: 'https://schedule-collection-dot-whr-lar-returns-portal-qa.appspot.com/orders'
        }
      }
    },
    MICRO_SERVICES: {
      SAP_HYBRIS: {
        ROUTES: {
          BASE_URL: 'https://whr-lar-returns-portal-qa.appspot.com/',
          TOKEN_VALIDATION_URL: 'https://lojapecasoriginais.com.br/usertoken/validate'
        }
      },
      SCHEDULE_COLLECTION: {
        EMAIL: url_email_qa
      },
      SHEETS: {
        EMAIL: url_email_qa
      },
      USER_MANAGEMENT: {
        EMAIL: url_email_qa
      },
      CAUSE: {
        BASE_URL: `${url_return_solicitation_qa}`,
        CAUSE_LIST: `${url_return_solicitation_qa}/return-request`,
      },
      FILES: {
        BASE_URL: 'https://files-service-dot-whr-lar-returns-portal-qa.appspot.com/files'
      }
    }
  },
  DEV: {
    PORT_BASE: 9000,
    BACK_OFFICE: {
      DATABASE_ACCESS: {
        PORT: database_port,
        BASE_URL: `${base_dev}:3306`
      },
      REQUEST_APPROVAL: {
        RESEARCH: {
          RESEARCH_ALL: `${base_dev}:${return_solicitation_port}/all`,
          RESEARCH_FATURATED: `${base_dev}:${return_solicitation_port}/faturated`,
          RESEARCH_PENDING: `${base_dev}:${return_solicitation_port}/pending`,
          RESEARCH_WAITING_COLLECTION_DATE: `${base_dev}:${return_solicitation_port}/waiting-for-collection-date`,
          RESEARCH_WAITING_OI: `${base_dev}:${return_solicitation_port}/waiting-for-oi`,
          RESEARCH_WAITING_REVENUE: `${base_dev}:${return_solicitation_port}/waiting-revenue`
        },
        INVERSE_ORDER: {
          BASE_URL: `${base_dev}:${return_solicitation_port}/inverse-order`
        },
        REQUEST_APPROVAL: {
          PORT: return_solicitation_port,
          BASE_URL: `${base_dev}:${return_solicitation_port}/return-request`
        },
        SCHEDULE_COLLECTION: {
          BASE_URL: `${base_dev}:${return_solicitation_port}/orders`
        },
        SHEETS: {
          BASE_URL: `${base_dev}:${sheets_port}`
        }
      },
      USER_MANAGEMENT: {
        BASE_URL: `${base_dev}:${user_management_port}/user-management`
      },
      AUTH: {
        PORT: login_port,
        BASE_URL: `${base_dev}:${login_port}`
      }
    },
    CLIENT: {
      PORT_BASE: 8000,
      CUSTOMER: {
        PORT: customer_port,
        BASE_URL: `${base_dev}:${customer_port}`
      },
      EMAIL: {
        // pode ser o mesmo de prod
        BASE_URL: url_email_prod
      },
      RETURN_SOLICITATION: {
        ITEMS: {
          BASE_URL: `${base_dev}:${return_solicitation_port}/return-request/materials`
        },
        RETURN_SOLICITATION: {
          BASE_URL: `${base_dev}:${return_solicitation_port}/return-request`,
          // pode ser o mesmo de prod
          EMAIL_URL: url_email_prod
        },
        SPECIFIC_FIELDS: {
          BASE_URL: `${base_dev}:${return_solicitation_port}`
        }
      },
      RETURN_TRACKING: {
        SOLICITATIONS: {
          BASE_URL: `${base_dev}:${return_tracking_port}`
        }
      },
      SCHEDULE_COLLECTION: {
        COLLECTIONS: {
          BASE_URL: `${base_dev}:${schedule_port}`
        }
      }
    },
    MICRO_SERVICES: {
      PORT: sap_hybris_port,
      SAP_HYBRIS: {
        ROUTES: {
          PORT: sap_hybris_port,
          BASE_URL: `${base_dev}:${sap_hybris_port}`,
          TOKEN_VALIDATION_URL: `${base_dev}:${sap_hybris_port}/usertoken/validate`
        }
      },
      SCHEDULE_COLLECTION: {
        PORT: schedule_port,
        // pode ser o mesmo de prod
        EMAIL: url_email_prod
      },
      SHEETS: {
        PORT: sheets_port,
        // pode ser o mesmo de prod
        EMAIL: url_email_prod
      },
      USER_MANAGEMENT: {
        PORT: user_management_port,
        BASE_URL: `${base_dev}:${user_management_port}/user-management`,
        // pode ser o mesmo de prod
        EMAIL: url_email_prod
      },
      EMAIL: {
        PORT: email_port
      },
      FILES: {
        PORT: files_port,
        BASE_URL: `${base_dev}:${files_port}/files`
      },
      INVERSE_ORDER: {
        PORT: inverse_order_port
      },
      LOGIN: {
        PORT: login_port
      },
      RESEARCH: {
        PORT: research_port
      },
      RETURN_TRACKING: {
        PORT: return_tracking_port
      },
      SAP_PIXI: {
        PORT: sap_pixi_port
      },
      AUTH: {
        PORT: login_port
      },
      CAUSE: {
        CAUSE_LIST: `${base_dev}:${return_solicitation_port}/return-request`,
      }
    }
  }
}